// extracted by mini-css-extract-plugin
export default {"InfoText":"InfoText_InfoText__QboN8","small":"InfoText_small__L1BUJ","info":"InfoText_info__LulMl","success":"InfoText_success__Hjonr","error":"InfoText_error__hU6BO"};